// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1EUx8","modal":"Modal_modal__cWUHp","slide-down":"Modal_slide-down__NBBFc","content":"Modal_content__mikrT"};